var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.userData.name === 'Maciej Kryczka')?_c('b-button',{staticClass:"backButton",on:{"click":function($event){return _vm.actualization()}}},[_vm._v("AKTUALIZACJA BAZY")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }